import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import ButtonPill from 'components/lib/ButtonPill';
import { MailboxConnectionActionItemType } from 'types/actionCenter';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px;
  border-top: 1px solid var(--lighter-gray);
  font-family: var(--font-regular);
`;

const Details = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled(Typography.Text)`
  color: var(--text-secondary);
  font-family: var(--font-bold);
`;

const Description = styled(Typography.Text)`
  color: var(--text-secondary);
  font-family: var(--font-regular);
  font-size: 10px;
`;

const ActionButton = styled(ButtonPill)`
  flex: 0 0 auto;
  height: 26px;
  padding: 0 12px;
  border-color: var(--button-blue);
  background: var(--white);
  color: var(--button-blue);
  font-family: var(--font-bold);
`;

type Props = {
  item: MailboxConnectionActionItemType;
  loading: boolean;
  onAction: (item: MailboxConnectionActionItemType) => void;
};

const ActionCenterItem = ({ item, loading, onAction }: Props) => {
  return (
    <Container>
      <Details>
        <Title>{item.title}</Title>
        <Description>{item.description}</Description>
      </Details>
      <ActionButton loading={loading} onClick={() => onAction(item)}>
        {item.action_label}
      </ActionButton>
    </Container>
  );
};

export default ActionCenterItem;
